<template>
  <v-container grid-list-xl fluid>
    


    <v-container v-if="SuperAdmin || this.$local_storage.get('id_grupo') > 0"  >
      <v-row v-if="!this.$local_storage.get('id_grupo') > 0 || SuperAdmin " >
        <v-col cols="12" sm="6" :lg="3" >
       <v-select :items="grupos" v-model="id_grupo" item-text="nombre" item-value="id_grupo" label="Filtrar por Grupo.." @change="selectgrupo()" >
      </v-select>
        </v-col>
      </v-row>

      <v-row>
        <!-- CUADRO 1 - Pedimentos -->
        <v-col cols="12" sm="6" :lg="3" >
          <base-material-stats-admin
            color="purple"
            icon="mdi-clock-outline"
            :key="pedimentos"
            title="TOTAL DE PEDIMENTOS"
            :value="pedimentos"
          />
        </v-col>

        <!-- CUADRO 2 - Archivos -->
        <v-col cols="12" sm="6" :lg="3" >
          <base-material-stats-admin
            color="cyan"
             :key="archivos"
            icon="mdi-clock-outline"
            title="TOTAL DE ARCHIVOS "
            :value="archivos"
          />
        </v-col>

        <!-- CUADRO 3 - Espacio -->
        <v-col cols="12" sm="6" :lg="3" >
          <base-material-stats-admin
            color="blue"
            icon="mdi-clock-outline"
             :key="espacio"
            title="ESPACIO UTILIZADO GB"
            :value="espacio"
          />
        </v-col>
        <!-- CUADRO 4 - inconsistencias -->
        <v-col cols="12" sm="6" :lg="3" >
          <base-material-stats-admin
            color="pink"
            icon="mdi-clock-outline"
            title="INCONSISTENCIAS"
             :key="inconsistencias"
            :value="inconsistencias"
          />
        </v-col>
      </v-row>

        <v-tabs
            grow
          >
            <v-tab key="1" >
                <v-icon lass="white--text" >mdi-gauge</v-icon>&nbsp;
                ESTADO GENERAL POR CLIENTE
            </v-tab>
            <v-tab key="2" >
                <v-icon lass="white--text" >mdi-file-tree</v-icon>&nbsp;
                ARCHIVOS EN EXPEDIENTE
            </v-tab>
            <v-tab key="3" >
                <v-icon lass="white--text" >mdi-calendar</v-icon>&nbsp;
                RECUPERACIÓN DIARIA
            </v-tab>
            <v-tab key="4" >
                <v-icon lass="white--text" >mdi-webhook</v-icon>&nbsp;
                RECUPERACIÓN DATASTAGE
            </v-tab>
            <v-tab key="6" v-if="!this.id_grupo>0" >
                <v-icon lass="white--text" >mdi-calendar</v-icon>&nbsp;
                RECUPERACIÓN PROGRAMADAS
            </v-tab>
            <!-- <v-tab key="5" @click="getcalendar();" >
                <v-icon lass="white--text" >mdi-floppy</v-icon>&nbsp;
                RESUMEN DATASTAGE
            </v-tab> -->
            <v-tab key="7" v-if="!this.id_grupo>0">
              <v-icon lass="white--text">mdi-account-clock-outline</v-icon>&nbsp;
              ACCESOS DE CLIENTES
            </v-tab>


      <v-tab-item key="1" >
        <v-card class="pa-1 pl-4 pr-4" style="margin:0px;" >

        <v-card-actions style=" position:relative; padding:0; height:0px; margin-top:40px; z-index: 999;" >
          <v-spacer></v-spacer>
          <div style="margin-top: -5px;">
            <v-switch small v-model="inactivos" @change="getAvanceGlobal">
              <template slot="label" >
                <span style="margin-top:7px; margin-right: 20px;">Inactivas</span>
            </template>
            </v-switch>
          </div>
          &nbsp;
          <exportar-excel
            style="margin-top:-10px; z-index:1000"
            :data="data_avanceGlobal"
            :exportFields="data_avanceGlobal_excel"
            name="EstadoGeneralXrfc.xlsx"
          >
            <v-btn small icon color="green"  title="Descargar Información" v-tippy>
              <v-icon dark>mdi-table</v-icon>
            </v-btn>
          </exportar-excel>
        </v-card-actions>

        <v-card-text>
          <v-client-table
            ref="t_avance_global"
            :data="data_avanceGlobal"
            :columns="columns_avanceGlobal"
            :options="avanceGlobal_options"
            class="elevation-2 pa-2"
            style="margin-top:-50px"
          >
            <template slot="noResults" >
              <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
            </template>
            <div
              slot="espacio"
              slot-scope="props"
              class="text-end"
            >{{formatBites(props.row.espacio)}}</div>
            <div
              slot="cantidad"
              slot-scope="props"
              class="text-end"
            >{{formatNumber(props.row.cantidad)}}</div>
              <div
              slot="total_partidas"
              slot-scope="props"
              class="text-end"
            >{{formatNumber(props.row.total_partidas)}}</div>
              <div
              slot="total_coves"
              slot-scope="props"
              class="text-end"
            >{{formatNumber(props.row.total_coves)}}</div>
              <div
              slot="total_edocuments"
              slot-scope="props"
              class="text-end"
            >{{formatNumber(props.row.total_edocuments)}}</div>
              <div
              slot="total_remesas"
              slot-scope="props"
              class="text-end"
            >{{formatNumber(props.row.total_remesas)}}</div>
            <div slot="archivos" slot-scope="props" class="text-end" >
              <a
                v-if="props.row.archivos>0"
                @click="getTotal_avance_tipo_cliente(props.row.rfc)"
              >{{formatNumber(props.row.archivos)}}</a>
              <span v-if="props.row.archivos==0" >{{formatNumber(props.row.archivos)}}</span>
            </div>

            <template slot="avance" slot-scope="props" >
              <v-progress-linear
                v-model="props.row.avance"
                height="15"
                color="#00ff00"
                >
            <strong>{{ props.row.avance }}%</strong>
            </v-progress-linear>
            </template>
            <template slot="h__avance" >
                <div style="min-width:100px" >Avance </div>
            </template>
            <div
              slot="auditados"
              slot-scope="props"
              class="text-end"
            >{{formatNumber(props.row.auditados)}}</div>
            <div slot="inconsistencias" slot-scope="props" class="text-center" >
              <a
                v-if="props.row.inconsistencias>0"
                @click="getInconsistencias(props.row.rfc)"
              >{{props.row.inconsistencias}}</a>
              <span v-if="props.row.inconsistencias==0" >{{props.row.inconsistencias}}</span>
            </div>
            <div
              slot="noauditados"
              slot-scope="props"
              class="text-end"
            >{{formatNumber(props.row.noauditados)}}</div>
            <div
              slot="promedio"
              slot-scope="props"
              class="text-end"
            >{{formatDouble((props.row.espacio /1048576) /props.row.cantidad, 2)}} MB</div>
          </v-client-table>
        </v-card-text>
        </v-card>

        <v-card  v-show="data_inconsistencias.length > 0">
            <v-card class="pa-2 red white--text" style="margin-bottom:0px;" >
            <v-icon small class="white--text" >list</v-icon>&nbsp;
            PEDIMENTOS QUE PRESENTAN INCONSISTENCIAS EN AUDITORÍAS -
            <b>{{rfc_sel}}</b>
            </v-card>
            <v-card-actions style="padding:0; height:20px; margin-top:-28px" >
            <v-spacer></v-spacer>
            <exportar-excel
                :data="datafiltered"
                :exportFields="data_inconsistencias_excel"
                :name="'Inconsistencias_' + rfc_sel +'.xlsx'"
            >
                <v-btn color="white" icon title="Descargar Información" v-tippy>
                <v-icon dark>mdi-table</v-icon>
                </v-btn>
            </exportar-excel>
            <v-btn color="white" icon title="Ocultar Tabla" @click="ocultaInconsistencias()" v-tippy>
                <v-icon dark>mdi-close</v-icon>
            </v-btn>
            </v-card-actions>
            <v-card-text>
            <div class="pa-5" v-if="to_download.length>0">
                <v-btn

                    color="green"
                    title="Marcar Atendidas todas las Seleccionadas"
                    @click="atendertodas()"  v-tippy
                    small
                >
                    <v-icon dark>mdi-clipboard-check-outline</v-icon>Atender todas
                </v-btn>&nbsp;&nbsp;
                <v-btn

                    color="red"
                    title="Volver Auditar Todas las Seleccionadas"
                    @click="auditartodas()" v-tippy
                    small
                >
                    <v-icon dark>mdi-book-search</v-icon>Auditar todas
                </v-btn>&nbsp;&nbsp;
                 <v-btn

                    color="secondary"
                    title="Enviar Todas a Recuperación Directa"
                    @click="reenviartodas()"  v-tippy
                    small
                >
                    <v-icon dark>mdi-swap-horizontal-bold</v-icon>Enviar Todas a Recuperación Directa
                </v-btn>&nbsp;&nbsp;
                <v-btn

                    color="purple"
                    title="Enviar Todas a Recuperación Programada"
                    @click="reenviartodas(1)"  v-tippy
                    small
                >
                    <v-icon dark>mdi-swap-horizontal-bold</v-icon>Enviar Todas a Recuperación Programada
                </v-btn>
            </div>

            <v-client-table
                ref="vuetable"
                :data="data_inconsistencias"
                :columns="columns_inconsistencias"
                :options="inconsistencias_options"
                class="elevation-2 pa-5 scroll-table"
            >
                <template slot="noResults" >
                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                </template>
                  <div slot="filter__id" >
                    <input type="checkbox" class="form-control check-all" v-model='allChecked' @change="check_all()" >
                  </div>
                  <template slot="id" slot-scope="props"  >
                    <div style="display:flex; justify-content:center;" >
                      <input :id="props.row.id" type="checkbox" v-model="to_download" :value="props.row.id" />
                    </div>
                  </template>


                <div slot="actions" slot-scope="props" class="text-center" >
                <v-btn
                    fab x-small
                    color="green"
                    title="Marcar como Atendido"
                    @click="atender(props.row)"  v-tippy
                >
                    <v-icon dark>mdi-clipboard-check-outline</v-icon>
                </v-btn>
                <v-btn
                    fab x-small
                    color="red"
                    title="Volver Auditar"
                    @click="auditarPedimento(props.row.id)" v-tippy
                >
                    <v-icon dark>mdi-book-search</v-icon>
                </v-btn>
                <v-btn v-if="props.row.tipo != 'Webservice' && props.row.tipo != 'Partidas Incompletas'"
                    fab x-small
                    color="secondary"
                    title="Enviar a Recuperación Directa"
                    @click="reenviarArchivo(props.row)"  v-tippy
                >
                    <v-icon dark>mdi-swap-horizontal-bold</v-icon>
                </v-btn>
                <v-btn v-if="props.row.tipo != 'Webservice' && props.row.tipo != 'Partidas Incompletas'"
                    fab x-small
                    color="purple"
                    title="Enviar a Recuperación Programada"
                    @click="reenviarArchivo(props.row, 1)"  v-tippy
                >
                    <v-icon dark>mdi-server</v-icon>
                </v-btn>
                <v-btn v-if="props.row.tipo == 'Partidas Incompletas'"
                    fab x-small
                    color="blue"
                    title="Enviar Solo Partidas Recuperación Directa"
                    @click="reenviarArchivoPartidas(props.row)"  v-tippy
                >
                    <v-icon dark>mdi-multiplication</v-icon>
                </v-btn>
                <v-btn v-if="props.row.tipo == 'Partidas Incompletas'"
                    fab x-small
                    color="cyan"
                    title="Enviar Solo Partidas Recuperación Programada"
                    @click="reenviarArchivoPartidas(props.row, 1)"  v-tippy
                >
                    <v-icon dark>mdi-server</v-icon>
                </v-btn>
                </div>
            </v-client-table>
            </v-card-text>
        </v-card>

        <v-card v-if="data_total_avance_tipo_cliente.length>0" >
            <v-card class="pa-2 yellow black--text" style="margin-bottom:0px;" >
            <v-icon small class="black--text" >list</v-icon>&nbsp;
            EXPEDIENTE DE ARCHIVOS ELECTRÓNICOS DE -
            <b>{{rfc_sel}}</b>
            </v-card>
            <v-card-actions style="padding:0; height:20px; margin-top:-28px" >
            <v-spacer></v-spacer>

            <v-btn color="black" icon title="Ocultar Tabla" @click="ocultaAvance()" v-tippy>
                <v-icon dark>mdi-close</v-icon>
            </v-btn>
            </v-card-actions>
            <v-card-text>
            <table class="VueTables__table table table-striped table-bordered table-hover" >
                <thead>
                <tr>
                    <th class="text-left" >TIPO</th>
                    <th class="text-end" >RECUPERADO</th>
                    <th class="text-end" >PENDIENTE</th>
                    <th class="text-end" >NO RECUPERABLE</th>
                    <th class="text-end" >ERROR</th>
                    <th class="text-end" >CLAVE/SELLOS</th>
                    <th class="text-end" >REPROGRAMADO</th>
                    <th class="text-end" >NO DEFINIDO</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,i) in tipos_archivo" :key="i" >
                    <td>{{item}}</td>
                    <td
                    class="text-end"
                    >{{formatNumber(data_total_avance_tipo_cliente[i]["RECUPERADO"])}}</td>
                    <td
                    class="text-end"
                    >{{formatNumber(data_total_avance_tipo_cliente[i]["PENDIENTE"])}}</td>
                    <td
                    class="text-end"
                    >{{formatNumber(data_total_avance_tipo_cliente[i]["NO RECUPERABLE"])}}</td>
                    <td class="text-end" >{{formatNumber(data_total_avance_tipo_cliente[i]["ERROR"])}}</td>
                    <td
                    class="text-end"
                    >{{formatNumber(data_total_avance_tipo_cliente[i]["CLAVE/SELLOS"])}}</td>
                    <td
                    class="text-end"
                    >{{formatNumber(data_total_avance_tipo_cliente[i]["REPROGRAMADO"])}}</td>
                    <td
                    class="text-end"
                    >{{formatNumber(data_total_avance_tipo_cliente[i]["NO DEFINIDO"])}}</td>
                </tr>
                </tbody>
            </table>
            </v-card-text>
        </v-card>
      </v-tab-item >
      <v-tab-item key="2" >
        <v-card class="pa-2 pl-6 pr-6" style="margin:0px;" v-if="data_total_avance_tipo.length>0" >
        <v-card class="pl-4" style="margin-bottom:0px;" >
          CONTEO GENERAL DE ARCHIVOS RECUPERADOS Y GENERADOS.
        </v-card>
        <v-card-text>
          <table class="VueTables__table table table-striped table-bordered table-hover" >
            <thead>
              <tr>
                <th class="text-left" >TIPO</th>
                <th class="text-end" >RECUPERADO</th>
                <th class="text-end" >PENDIENTE</th>
                <th class="text-end" >NO RECUPERABLE</th>
                <th class="text-end" >ERROR</th>
                <th class="text-end" >CLAVE/SELLOS</th>
                <th class="text-end" >REPROGRAMADO</th>
                <th class="text-end" >NO DEFINIDO</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in tipos_archivo" :key="i" >
                <td>{{item}}</td>
                <td class="text-end" >{{formatNumber(data_total_avance_tipo[i]["RECUPERADO"]) || 0}}</td>
                <td class="text-end" >{{formatNumber(data_total_avance_tipo[i]["PENDIENTE"]) || 0}}</td>
                <td class="text-end">
                  <v-chip x-small outlined text-color="blue" title="Exportar a Excel" v-tippy 
                      @click="get_excel_no_recuperables(item, formatNumber(data_total_avance_tipo[i]['NO RECUPERABLE']))">
                      {{formatNumber(data_total_avance_tipo[i]["NO RECUPERABLE"]) || 0}}
                    </v-chip>
                </td>
                <td class="text-end" >{{formatNumber(data_total_avance_tipo[i]["ERROR"]) || 0}}</td>
                <td
                  class="text-end"
                >{{formatNumber(data_total_avance_tipo[i]["CLAVE/SELLOS"]) || 0}}</td>
                <td
                  class="text-end"
                >{{formatNumber(data_total_avance_tipo[i]["REPROGRAMADO"]) || 0}}</td>
                <td class="text-end" >{{formatNumber(data_total_avance_tipo[i]["NO DEFINIDO"]) || 0}}</td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
        </v-card>
      </v-tab-item >
      <v-tab-item key="3" >
          <v-card class="pa-1" style="margin:0px;" >
        <v-card class="pl-4" style="margin-bottom:0px;" >
          {{ erroresrecu ? 'CONTEO DE ARCHIVOS CON ERROR EN EL DÍA POR CLIENTE': 'CONTEO DE ARCHIVOS RECUPERADOS EN EL DÍA POR CLIENTE' }}
        </v-card>

        <v-dialog v-model="dialog" max-width="300px" >
          <v-card>
            <v-card-text>
              <h5>Pedimentos Recuperación Diaria</h5>
              <h5 class="caption gray--text font-weight-light" >Seleccione la fecha a consultar</h5>
              <v-container grid-list-md text-xs-center>
                <v-form ref="f_consulta_dia" >
                  <v-row no-gutters dense>
                    <v-col>
                      <v-menu
                        offset-x
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        min-width="190px"
                        offset-y
                      >
                        <template v-slot:activator="{ on }" >
                          <v-text-field
                            clearable
                            v-on="on"
                            v-model="fecha"
                            label="Fecha"
                            color="secondary"
                            prepend-icon="event"
                            @blur="fecha = parseDate(fecha)"
                            v-mask="'####-##-##'"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          v-model="fecha"
                          color="secondary"
                          scrollable
                          locale="es-mx"
                          @input="menu = false"
                        >


                          <v-spacer />
                          <v-btn color="secondary" x-small @click="menu = false" >Cancelar</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-switch v-model="diaria" label="Solo Consulta Diaria" ></v-switch>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small @click="dialog = false" >Cancelar</v-btn>
              <v-btn
                small
                :loading="loading"
                :disabled="loading"
                color="primary"
                @click="loader = 'loading'; loading=true; getxDia();"
              >Consultar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div
          class="d-inline-flex text-right"
          style="position:absolute; z-index:1; margin-top:-30px; padding-right:40px;  width:100%"
        >
          <v-spacer />
          <div id="dvswtich" style="margin-top: -4px;">
            <v-switch small v-model="erroresrecu" @change="getxDia">
              <template slot="label" >
                <span style="margin-top:7px; margin-right: 20px; font-size: 14px;">Errores</span>
            </template>
            </v-switch>
          </div>
          <span class="overline secondary--text font-weight-light" >
            FECHA: {{fecha}}
            <v-btn icon small color="secondary" title="Seleccionar Periodo" @click="dialog = !dialog" v-tippy>
              <v-icon dark>mdi-calendar</v-icon>
            </v-btn>
          </span>

          <exportar-excel
            :data="data_x_dia"
            :exportFields="data_xdia_excel"
            name="Recuperacion_Diaria.xlsx"
          >
            <v-btn color="green" icon small title="Descargar Información" v-tippy>
              <v-icon  dark>mdi-table</v-icon>
            </v-btn>
          </exportar-excel>
        </div>

            <v-client-table
              ref="t_x_dia"
              :data="data_x_dia"
              :columns="columns_xdia"
              :options="xdia_options"
              class="elevation-2 pa-2"
            >
              <template slot="noResults" >
                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
              </template>
              <template slot="search" >
                <v-alert icon="info" color="info" >No se encontró ningún registro</v-alert>
              </template>

              <template slot="h__1" >
                <v-icon small color="blue" >mdi-xml</v-icon>Pedimento
              </template>
              <template slot="h__2" >
                <v-icon small color="red" >mdi-file-pdf-box</v-icon>Pedimento
              </template>
              <template slot="h__3" >
                <v-icon small color="red" >mdi-file-pdf-box</v-icon>Simple
              </template>
              <template slot="h__4" >
                <v-icon small color="blue" >mdi-xml</v-icon>Estado
              </template>
              <template slot="h__5" >
                <v-icon small color="red" >mdi-file-pdf-box</v-icon>Estado
              </template>
              <template slot="h__6" >
                <v-icon small color="blue" >mdi-xml</v-icon>Partida
              </template>
              <template slot="h__7" >
                <v-icon small color="blue" >mdi-xml</v-icon>Cove
              </template>
              <template slot="h__8" >
                <v-icon small color="red" >mdi-file-pdf-box</v-icon>Cove
              </template>
              <template slot="h__10" >
                <v-icon small color="red" >mdi-file-pdf-box</v-icon>Acuse
              </template>
              <template slot="h__11" >
                <v-icon small color="blue" >mdi-xml</v-icon>Edoc
              </template>
              <template slot="h__12" >
                <v-icon small color="red" >mdi-file-pdf-box</v-icon>Edoc
              </template>
              <template slot="h__14" >
                <v-icon small color="red" >mdi-file-pdf-box</v-icon>Acuse
              </template>
              <template slot="h__15" >
                <v-icon small color="blue" >mdi-xml</v-icon>Remesa
              </template>
              <template slot="h__16" >
                <v-icon small color="red" >mdi-file-pdf-box</v-icon>Remesa
              </template>
              <template slot="h__18" >
                <v-icon small color="red" >mdi-file-pdf-box</v-icon>Acuse
              </template>
            </v-client-table>

      </v-card>
      </v-tab-item >
      <v-tab-item key="4" >
          <v-card class="pa-1 pr-4 pl-4" style="margin:0px;" >
        <v-card class="pa-2" style="margin-bottom:0px;" >
          AVANCE DE RECUPERACIÓN ARCHIVOS ZIP CARGADOS EN DATASTAGE
        </v-card>
        <v-card-actions style="padding:0; height:20px; margin-top:-25px; margin-rigth:40px;" >
          <v-spacer></v-spacer>

          <v-btn color="#00ff00" small icon @click="getBarras()" title="Actualizar Avance" v-tippy>
            <v-icon color="black" >mdi-refresh</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-client-table
            ref="t_barras"
            :data="datos_barras"
            :columns="columns_barras"
            :options="barras_options"
            class="elevation-2 pa-2"
          >
            <template slot="noResults" >
              <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
            </template>
            <template slot="barra.porcentaje" slot-scope="props"  >
                <v-progress-linear
                    v-model="props.row.barra.porcentaje"
                    height="15"
                    color="#00ff00"
                >
                    <strong>{{ props.row.barra.porcentaje }}%</strong>
                </v-progress-linear>
            </template>
            <template slot="barra.fecha" slot-scope="props" >
              {{props.row.barra.fecha.substring(0, 10)}}
            </template>
            <template slot="barra.fecha_inicio" slot-scope="props" >
              {{props.row.barra.fecha_inicio.substring(0, 10)}}
            </template>
            <template slot="barra.fecha_fin" slot-scope="props" >
              {{props.row.barra.fecha_fin.substring(0, 10)}}
            </template>
            <template slot="h__barra.porcentaje" >
                <div style="min-width:200px" >Avance </div>
            </template>
            <div slot="actions" slot-scope="props" class="text-center" >
              <v-btn
                fab x-small
                color="secondary"
                title="Resetear Recuperación"
                 @click="reenviarGlosa(props.row)"
              >
                <v-icon dark>mdi-swap-horizontal-bold</v-icon>
              </v-btn>
            </div>
          </v-client-table>
        </v-card-text>
      </v-card>
      </v-tab-item >
       <v-tab-item key="6" v-if="!this.id_grupo>0"  >
        <v-card class="pa-1 pr-4 pl-4" style="margin:0px;" >
        <v-card class="pa-2" style="margin-bottom:0px;" >
          RECUPERACIONES PROGRAMADAS EN LOS ÚLTIMOS 30 DÍAS
        </v-card>
        <v-card-actions style="padding:0; height:20px; margin-top:-25px; margin-rigth:40px;" >
          <v-spacer></v-spacer>

           <exportar-excel
            :data="programadas"
            :exportFields="data_programadas_excel"
            name="Recuperaciones_Programadas.xlsx"
          >
            <v-btn color="green" icon small title="Descargar Información" v-tippy>
              <v-icon  dark>mdi-table</v-icon>
            </v-btn>
          </exportar-excel>
        </v-card-actions>
        <v-card-text>
           <v-client-table
            ref="t_programadas"
            :data="programadas"
            :columns="columns_programadas"
            :options="programadas_options"
            class="elevation-2 pa-2"
          >
            <template slot="noResults" >
              <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
            </template>

           <!--  <template slot="fecha_inicial" slot-scope="props" >
              {{props.row.fecha_inicial.substring(0, 10)}}
            </template>
            <template slot="fecha_final" slot-scope="props" >
              {{props.row.fecha_final.substring(0, 10)}}
            </template>
            <template slot="fecha_solicitud" slot-scope="props" >
              {{props.row.fecha_solicitud.substring(0, 10)}}
            </template>
            <template slot="estatus" slot-scope="props" >
              {{props.row.estatus==0?"PENDIENTE":"PROCESADO"}}
            </template> -->
          </v-client-table>

        </v-card-text>
       </v-card>
      </v-tab-item >
      <!-- <v-tab-item key="5" >
        <v-card class="pa-1 pr-4 pl-4" style="margin:0px;" >
        <v-card class="pa-2" style="margin-bottom:0px;" >
          RESUMEN ARCHIVOS ZIP CARGADOS EN DATASTAGE
        </v-card>
        <v-card-actions style="padding:0; height:20px; margin-top:-25px; margin-rigth:40px;" >
          <v-spacer></v-spacer>

           <exportar-excel
            :data="data_calendar"
            :exportFields="data_calendar_excel"
            name="Resumen_Glosas_Cargadas.xlsx"
          >
            <v-btn color="green" icon small title="Descargar Información" v-tippy>
              <v-icon  dark>mdi-table</v-icon>
            </v-btn>
          </exportar-excel>
        </v-card-actions>
        <v-card-text>
          <v-client-table
            ref="t_calendar"
            :data="data_calendar"
            :columns="columns_calendar"
            :options="calendar_options"
            class="elevation-2 pa-2"
          >
            <template slot="noResults" >
              <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
            </template>
             <div slot="h__total" class="text-center" >
               Total
            </div>
            <div slot="total" class="text-center" slot-scope="props" >

                  {{props.row.total}}

            </div>
             <div slot="h__falta" class="text-center" >
               Faltantes
            </div>
            <div slot="falta" class="text-center" slot-scope="props" >
            <a
                  color="primary"
                  dark
                  :title="props.row.meses_faltantes"
                  @click.stop="dialog_faltan = true" v-tippy
                >
                  {{props.row.falta}}
                </a>
            </div>
          </v-client-table>
        </v-card-text>
       </v-card>
      </v-tab-item > -->

      <v-tab-item key="7" v-if="!this.id_grupo>0">
          <v-card class="pa-1" style="margin:0px;" >
            <v-card class="pl-4" style="margin-bottom:0px;" >
              CONTEO DE ACCESOS POR CLIENTES ACTIVOS
            </v-card>

        <v-dialog v-model="dialog_login" max-width="400px" >
          <v-card>
            <v-card-text>
              <h5>Consultar Accesos de Clientes</h5>
              <h5 class="caption gray--text font-weight-light" >Seleccione las fechas a consultar</h5>
              <v-container grid-list-md text-xs-center>
                <v-form ref="f_consulta_dia" >
                  <v-row no-gutters dense>
                    <v-col cols="12">
                      <v-menu offset-x ref="menu_login" v-model="menu_login_1" :close-on-content-click="false" transition="scale-transition" min-width="190px" offset-y>
                        <template v-slot:activator="{ on }" >
                          <v-text-field clearable v-on="on" v-model="fecha_de_login" label="Fecha De:" color="secondary" prepend-icon="event" @blur="fecha_de_login = parseDate(fecha_de_login)" v-mask="'####-##-##'"></v-text-field>
                        </template>
                        <v-date-picker v-model="fecha_de_login" color="secondary" scrollable locale="es-mx" @input="menu_login_1 = false">
                          <v-spacer />
                          <v-btn color="secondary" x-small @click="menu_login_1 = false" >Cancelar</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row no-gutters dense>
                    <v-col>
                      <v-menu offset-x ref="menu_login_2" v-model="menu_login_2" :close-on-content-click="false" transition="scale-transition" min-width="190px" offset-y>
                        <template v-slot:activator="{ on }" >
                          <v-text-field clearable v-on="on" v-model="fecha_a_login" label="Fecha A:" color="secondary" prepend-icon="event" @blur="fecha_a_login = parseDate(fecha_a_login)" v-mask="'####-##-##'"></v-text-field>
                        </template>
                        <v-date-picker v-model="fecha_a_login" color="secondary" scrollable locale="es-mx" @input="menu_login_2 = false">
                          <v-spacer />
                          <v-btn color="secondary" x-small @click="menu_login_2 = false" >Cancelar</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small @click="dialog_login = false" >Cancelar</v-btn>
              <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; getlogins();">Consultar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div class="d-inline-flex text-right" style="position:absolute; z-index:1; margin-top:-30px; padding-right:40px;  width:100%">
          <v-spacer />
          <span class="overline secondary--text font-weight-light" >
            FECHA: {{fecha_de_login}} - {{fecha_a_login}}
            <v-btn icon small color="secondary" title="Seleccionar Periodo" @click="dialog_login = !dialog_login" v-tippy>
              <v-icon dark>mdi-calendar</v-icon>
            </v-btn>
          </span>

          <exportar-excel :data="data_login" :exportFields="data_login_excel" name="AccesosClientes.xlsx">
            <v-btn color="green" icon small title="Descargar Información" v-tippy>
              <v-icon  dark>mdi-table</v-icon>
            </v-btn>
          </exportar-excel>
        </div>
        <v-client-table ref="t_x_dia" :data="data_login" :columns="columns_login" :options="login_options" class="elevation-2 pa-2">
          <template slot="noResults" >
            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
          </template>
          <template slot="search" >
            <v-alert icon="info" color="info" >No se encontró ningún registro</v-alert>
          </template>
        </v-client-table>

      </v-card>
      </v-tab-item >
      </v-tabs>


    </v-container>

  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  computed: {
    SuperAdmin() {
      return this.$local_storage.get("tipo_usuario") == "Super Usuario";
    },
    datafiltered() {

                let result = [];
            if (this.$refs.vuetable != null) {
               result = this.$refs.vuetable.allFilteredData;
                return result;
            } else {
               result = this.data_inconsistencias;
                return result;
            }
    },
  },

  mounted(){
    if (this.$local_storage.get("es_transportista")==1 && !this.SuperAdmin )
            this.$router.replace("/indext").catch(() => {});

      // // if (this.SuperAdmin ) {
      // if(this.$route.query.c == 1 ){
      //     this.$local_storage.set("soloCartaPorte", 0);
      //       this.$local_storage.set("carta_porte", 0);
      //       this.$store.state.carta_porte = 0;
      //       this.$local_storage.set("id_cliente", 0);
      //       this.$local_storage.set("cambio_cliente", true);
      //       this.$local_storage.set("rfc", "");
      //       this.$local_storage.set("razon", "");
      //       this.$local_storage.set("panel_grupo", 0);
      //       this.$local_storage.set("es_transportista", 0);
      //       this.$local_storage.set("rfc_grupo", "");
      //       this.$local_storage.set("nombre_grupo", "");
      //       this.$local_storage.set("id_grupo", 0);
      // }


  },
  async created() {


    if(this.$local_storage.get("id_grupo") > 0){
      this.id_grupo = this.$local_storage.get("id_grupo");
    }
    this.$user.set({
      id_cliente: 0,
    });
    this.$store.state.id_cliente = -1;
    if (this.SuperAdmin ||  this.id_grupo>0) {
      await this.getGrupos();
      await this.getAvanceGlobal();
      await this.getTotal_avance_tipo();
      await this.getProgramadas();

      var f = new Date();
      let y = f.getFullYear();
      let m = f.getMonth() + 1;
      let d = f.getDate();
      if (m < 10) m = "0" + m;
      f = y + "-" + m + "-" + d;

      this.fecha = f;
      this.fecha_a_login = f;
      this.fecha_de_login = f;

      await this.getxDia();
      await this.getBarras();
      await this.getlogins();
    }
    this.regenerarmenu();
  },
  data: () => ({
    inactivos: false,
    erroresrecu:false,
    menu_login_1: false,
    menu_login_2: false,
    fecha_de_login:"",
    fecha_a_login:"",
    fab: false,
    diaria: false,
    grupos:[],
    to_download: [],
    id_grupo: 0,
    menu: false,
    allChecked: false,
    dialog: false,
    dialog_faltan: false,
    dialog_login:false,
    loading: false,
    espacio: 0,
    datos_barras: [],
    pedimentos: 0,
    programadas: [],
    archivos: 0,
    inconsistencias: 0,
    fecha: "",
    rfc_sel: "",
    data_avanceGlobal: [],
    data_x_dia: [],
    data_inconsistencias: [],
    data_total_avance_tipo: [],
    data_total_avance_tipo_cliente: [],
    data_calendar: [],
    tipos_archivo: {
      1: "XML PEDIMENTO",
      2: "PDF PEDIMENTO",
      3: "PDF SIMPLE PEDIMENTO",
      4: "XML ESTADO PEDIMENTO",
      5: "PDF ESTADO PEDIMENTO",
      6: "XML PARTIDA",
      7: "XML COVE",
      8: "PDF COVE",
      10: "PDF ACUSE COVE",
      11: "XML EDOCUMENT",
      12: "PDF EDOCUMENT",
      14: "PDF ACUSE EDOCUMENT",
      15: "XML REMESA",
      16: "PDF REMESA",
      18: "PDF ACUSE REMESA",
    },
    columns_avanceGlobal: [
      "rfc",
      "nombre",
      "tipo_servicio",
      "cantidad",
      "total_partidas",
      "total_coves",
      "total_edocuments",
      "total_remesas",
      "espacio",
      "promedio",
      "archivos",
      "auditados",
      "inconsistencias",
      "avance",
    ],
    avanceGlobal_options: {
      filterable: true,
      filterByColumn: false,
      texts: {
        filter: "",
        filterPlaceholder: "Buscar",
      },
      orderBy: {
        column: "rfc",
        ascending: true,
      },
      headings: {
        rfc: "RFC",
        nombre: "Razón Social",
        tipo_servicio: "Tipo de Servicio",
        cantidad: "Pedimentos",
        "total_partidas": "Partidas",
        "total_coves":  "Coves",
        "total_edocuments": "Edocuments",
        "total_remesas": "Remesas",
        recuperados: "Recuperados",
        avance: "% Avance WS",
        promedio: "Promedio",
        espacio: "Espacio en Disco",
        auditados: "Auditados",
        noauditados: "Sin Auditar",
        inconsistencias: "Inconsistencias",
        faltantes: "Por Recuperar",
        archivos: "Total Archivos",
      },
    },
    data_avanceGlobal_excel: {
      RFC: "rfc",
      "Razón Social": "nombre",
      "Tipo de Servicio": "tipo_servicio",
      "% Avance de Recuperaciones": "avance",
      "Megas Ocupados": "espacio",
      "Total Pedimentos": "cantidad",
      "Total Partidas": "total_partidas",
      "Total Coves": "total_coves",
      "Total Edocuments": "total_edocuments",
      "Total Remesas": "total_remesas",
      "Pedimentos Auditados": "auditados",
      Inconsistencias: "inconsistencias",
      "Pedimentos Recuperados": "recuperados",
      "Sin Auditar": "noauditados",
      "Por Recuperar": "faltantes",
      "Total Archivos": "archivos",
    },
    columns_xdia: [
      "rfc",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "10",
      "11",
      "12",
      "14",
      "15",
      "16",
      "18",
    ],
    xdia_options: {
      filterable: true,
      filterByColumn: false,
      texts: {
        filter: "",
        filterPlaceholder: "Buscar",
      },
      orderBy: {
        column: "rfc",
        ascending: true,
      },
      headings: {
        rfc: "RFC",
        "1": "PED",
        "2": "PDF.PE",
        "3": "PDF.SP",
        "4": "XML.ES",
        "5": "PDF.ES",
        "6": "XML.PA",
        "7": "XML.CO",
        "8": "PDF.CO",
        "10": "PDF.AC",
        "11": "XML.ED",
        "12": "PDF.ED",
        "14": "PDF.AD",
        "15": "XML.RE",
        "16": "PDF.RE",
        "18": "PDF.AR",
      },
    },
    data_xdia_excel: {
      RFC: "rfc",
      "XML PEDIMENTO": "1",
      "PDF PEDIMENTO": "2",
      "PDF SIMPLE PEDIMENTO": "3",
      "XML ESTADO PEDIMENTO": "4",
      "PDF ESTADO PEDIMENTO": "5",
      "XML PARTIDA": "6",
      "XML COVE": "7",
      "PDF COVE": "8",
      "PDF ACUSE COVE": "10",
      "XML EDOCUMENT": "11",
      "PDF EDOCUMENT": "12",
      "PDF ACUSE EDOCUMENT": "14",
      "XML REMESA": "15",
      "PDF REMESA": "16",
      "PDF ACUSE REMESA": "18",
    },
    columns_inconsistencias: ["id", "tipo", "no_pedimento", "anio", "error", "en_server", "actions"],
    inconsistencias_options: {
      filterable:[ "tipo", "no_pedimento", "anio", "error", "en_server"],
      sortable: [ "tipo", "no_pedimento", "anio", "error", "en_server"],
      listColumns: {
                    tipo: [{
                            id: 'Datastage',
                            text: "Datastage"
                        },
                        {
                            id: 'Estado Pedimento',
                            text: "Estado Pedimento"
                        },
                        {
                            id: "Valor Pedimento",
                            text: "Valor Pedimento"
                        },
                        {
                            id: "Webservice",
                            text: "Webservice"
                        },
                        {
                            id: "Partidas Incompletas",
                            text: "Partidas Incompletas"
                        },
                    ]
                },
      headings: {
        id: "",
        tipo: "Tipo",
        no_pedimento: "Pedimento",
        anio: "Año",
        estatus: "Estatus",
        error: "Error",
        en_server: "Método de Recuperación",
        actions: "Operaciones",
      },
    },
    data_inconsistencias_excel: {
      Tipo: "tipo",
      Pedimento: "no_pedimento",
      Año: "anio",
      Error: "error",
    },

    columns_programadas: [  "rfc", "fecha_inicial", "fecha_final", "estatus", "usuario", "fecha_solicitud" ],
    programadas_options: {
      filterable: true,
      filterByColumn: false,
      texts: {
        filter: "",
        filterPlaceholder: "Buscar",
      },
      orderBy: {
        column: "id",
        ascending: false,
      },
      headings: {
        'rfc': "RFC",
        'fecha_inicial': "FECHA DE",
        'fecha_final': "FECHA A",
        'estatus': "ESTATUS",
        'usuario': "USUARIO",
        'fecha_solicitud':"FECHA DE SOLICITUD"
      },
    },
    data_programadas_excel: {
       "RFC":'rfc',
       "FECHA DE": 'fecha_inicial',
       "FECHA A": 'fecha_final',
        "ESTATUS": 'estatus',
        "USUARIO": 'usuario',
        "FECHA DE SOLICITUD": 'fecha_solicitud'
    },
    columns_calendar: ["rfc", "inicio", "fin", "total",  "falta", "fecha"],
    calendar_options: {
      filterable: true,
      filterByColumn: false,
      texts: {
        filter: "",
        filterPlaceholder: "Buscar",
      },
      orderBy: {
        column: "rfc",
        ascending: true,
      },
      headings: {
        'rfc': "RFC",
        'inicio': "Primero",
        'fin': "Ultimo",
        'total': "Total",
        'falta': "Faltantes",
        'fecha':"Ultima Actualización"
      },
    },
    data_calendar_excel: {
      "RFC": 'rfc',
      "Primero": 'inicio',
      "Ultimo": 'fin',
      "Total": 'total',
      "Faltantes": 'falta',
      "Ultima Actualización": 'fecha',
      "Meses Faltantes": 'meses_faltantes'
    },
    barras_options: {
      filterable: true,
      filterByColumn: false,
      texts: {
        filter: "",
        filterPlaceholder: "Buscar",
      },
      orderBy: {
        column: "rfc",
        ascending: false,
      },
      headings: {
        rfc: "RFC",
        razon:"Razón social",
        'barra.folio':"Folio",
        'barra.fecha':"Fecha",
        'barra.total_pedimentos':"Pedimentos",
        'barra.fecha_inicio':"Fecha Inicio",
        'barra.fecha_fin':"Fecha Termino",
        'barra.porcentaje': "Avance",
        'actions': "Opciones",
      },
    },
    columns_barras: [
      "rfc",
      "razon",
        "barra.folio",
        "barra.fecha",
        "barra.total_pedimentos",
        "barra.fecha_inicio",
        "barra.fecha_fin",
        "barra.porcentaje",
        "actions"
    ],
    meses: ["0", "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"],
    breadcrumbs: [
      {
        text: "Inicio",
        disabled: false,
        to: "/admin",
      },
      {
        text: "Panel de Administración",
        disabled: true,
        href: "",
      },
    ],
    colortema: false,
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: "",
      color: "",
    },
    columns_login: ["rfc", "nombre", "accesos", "tipo_servicio"],
    login_options: {
      filterable: true,
      filterByColumn: false,
      texts: {
        filter: "",
        filterPlaceholder: "Buscar",
      },
      orderBy: {
        column: "rfc",
        ascending: true,
      },
      headings: {
        rfc: "RFC",
        nombre: "Razón Social",
        accesos: "Login",
        tipo_servicio:"Tipo de Servicio"
      },
    },
    data_login:[],
    data_login_excel: {
      RFC: "rfc",
      "Razón Social": "nombre",
      "Accesos": "accesos",
      "Tipo de Servicio":"tipo_servicio"
    },
  }),
  beforeCreate() {

    if (this.$local_storage.get("tipo_usuario") != "Super Usuario" &&  this.$local_storage.get("tipo_usuario") != "Grupo" ) {
      if (this.$local_storage.get("id_cliente") > 0) {
        this.$router.push("/home").catch(()=>{});
      }else{
         this.$router.push("/login").catch(()=>{});
      }
      }

  },
  methods: {
  get_excel_no_recuperables: function(tipo_documento, lineas){

    this.$swal({
        type: "info",
        title: "Importante",
        text: "Se generará un excel con "+lineas+" líneas. ¿Desea continuar?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");    
            var self = this;
            var tipo_int = 0;
            for(var k in this.tipos_archivo){
              if(this.tipos_archivo[k] == tipo_documento){
                tipo_int = k;
                break;
              }
            }
            var data = {
              "rfc":"ADMINISTRACION",
              "usuario": this.$local_storage.get("id_usuario"),
              "tipo_reporte": tipo_int,
              "reporte_url": "/reportes_vucem/archivos_no_recuperables/",
              "nombre_reporte": "No Recuperables Admin",
              "tipo": "NoRecuperablesAdmin",      
            };    
            if (this.id_grupo>0){
              data["grupo"] = this.id_grupo;
            }    
            axios.post(this.$hostname + "reportes/save_reporte/", data)
              .then((res) => {        
                setTimeout(function () {
                    self.descargar_reporte();
                }, 25000); //Damos tiempo para generar el reporte (25 seg)
              })
              .catch((err) => {
                  let mensaje;
                  var titulo = "¡Operación no Permitida!";
                  var tipo = "error";
                  var footer = "";
                  if (typeof error.response !== "undefined") {
                    mensaje = error.response.data.mensaje;
                    if (error.response.status == 406) {
                      titulo = "¡Ya existe un reporte en proceso!";
                      tipo = "info";
                      footer = "Espere a que termine y vuelva a intentarlo"
                    }
                  } else {
                    mensaje = "Ocurrió un error al generar el reporte";
                  }
                  this.$swal({
                    type: tipo,
                    title: titulo,
                    text: mensaje,
                    footer: footer
                  });
                self.$root.$dialogLoader.hide();
              });
        }
      });    
        
  },
  descargar_reporte:function(intento=0){
    var self = this;
    let data = {
        rfc: "ADMINISTRACION",
        "tipo": "NoRecuperablesAdmin"
      };
      axios.post(this.$hostname + "reportes/get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
            });
            var reportes = this.datos.filter(e => parseInt(e.usuario) == parseInt(this.$local_storage.get("id_usuario",0)));//Solo el reporte que genero el usuario
            if(reportes.length>0 && [2,3].includes(reportes[0].estatus) && reportes[0].filename != ""){
                  //console.log("Reporte: ",reportes[0]);
                  if(reportes[0].estatus == 3){//3-Error, 2-Correcto
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al generar el reporte.",
                        footer: 'Intente nuevamente o comuníquese con Soporte',
                      });
                      this.$root.$dialogLoader.hide();
                  } else {
                      var datos = {
                        id: reportes[0].filename,
                        bucket: "production.econnect.ds"
                      }
                      axios.post(this.$hostname + 's3/download_url/', datos)
                        .then((res) => {
                          if (typeof res.data !== 'undefined') {
                            var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style = "display: none";
                            a.href = res.data.mensaje;
                            a.target = "_blank";
                            a.click();
                            a.parentNode.removeChild(a);

                          } else {
                            this.$swal({
                              type: "error",
                              title: "¡Operación no Permitida!",
                              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                              footer: '',
                            });
                          }
                        })
                        .catch((error) => {
                          var mensaje = "Ocurrió un error al descargar el archivo";
                          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                          this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                          });
                          console.log(error);
                        }).then(() => {
                          this.$root.$dialogLoader.hide();
                        });  
                  }
                              
              
            } else {
                if (intento > 4) {
                      this.$swal({
                          type: "info",
                          title: "¡Operación En Proceso!",
                          text: "El reporte sigue En Proceso. Recibirá una notificación cuando termine.",
                          footer: 'En la notificación podrá descargar el reporte.',
                      });
                      this.$root.$dialogLoader.hide();
                  } else {
                    setTimeout(function () {
                        self.descargar_reporte(intento + 1);
                    }, 25000); //Damos tiempo para generar el reporte (25 seg)
                  }
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);
          this.$root.$dialogLoader.hide();
        });
  },
  async atendertodas(){
    let self = this;
      self.$swal({
        type: "info",
        title: "Cuidado",
        text:
          "Esta acción marcara como atendidas la inconsistencias seleccionadas y ya no aparecerán. ¿Desea continuar?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
           await Promise.all(self.to_download.map(async (x) => {
              let data = {
                id_pedimento: x
              };

              self.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
             await axios
                .post(self.$hostname + "vucem/revisar_auditoria/", data)
                .then((res) => {

                })
                .catch((err) => {
                  //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
                })
                .then(() => {
                  self.$root.$dialogLoader.hide();
                });
            }));
            self.getInconsistencias(self.rfc_sel);

        }
      });

    },
  async auditartodas(){
    let self = this;
      self.$swal({
        type: "info",
        title: "Cuidado",
        text:
          "Esta acción enviara a auditar nuevamente la inconsistencias seleccionadas. ¿Desea continuar?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
           await Promise.all(self.to_download.map(async (x) => {

              let data = {
                      key: x,
                    };
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                 await axios
                      .post(this.$hostname + "pedimentos/auditar/", data)

                .then((res) => {
                })
                .catch((err) => {
                  //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
                })
                .then(() => {
                  self.$root.$dialogLoader.hide();
                });
            }));
            self.getInconsistencias(self.rfc_sel);

        }
      });

    },
  async reenviartodas(server){
    let self = this;

    if(server === 1) {
      var text_i = "Esta acción enviará recuperar todos los pedimentos con inconsistencias seleccionadas al servidor. ¿Desea continuar?";
    } else {
      var text_i = "Esta acción enviará recuperar todos los pedimentos con inconsistencias seleccionadas. ¿Desea continuar?";
    }
      self.$swal({
        type: "info",
        title: "Cuidado",
        text: text_i,
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
           await Promise.all(self.to_download.map(async (x) => {


                 let pedimento = self.data_inconsistencias.filter(item => {
                                return item.id == x
                 });

                let data = {
                  key: x,
                  tipo: 1,
                  filename: pedimento[0].no_pedimento,
                  estatus: 0, //Se deja en Pendiente para que lo vuelva a encolar
                  size: 0,
                  error: "",
                  usuario: self.$local_storage.get("id_usuario",""),
                  origen: "Panel Administrador",
                  en_server: 0
                };

                if(pedimento[0].tipo == 'Partidas Incompletas'){
                  var url_post = "https://apivucem.econnectpro.mx/vucem/actualizar_validacion_partidas/";
                } else if(pedimento[0].tipo == 'Estado Pedimento'){
                  var url_post = "https://apivucem.econnectpro.mx/vucem/actualizar_validacion/";

                  data = {
                    key: x,
                    tipo: 4,
                    filename: "Estado-" + pedimento[0].no_pedimento,
                    estatus: 0, //Se deja en Pendiente para que lo vuelva a encolar
                    size: 0,
                    error: "",
                    usuario: self.$local_storage.get("id_usuario",""),
                    origen: "Panel Administrador",
                    en_server: 0
                  }
                } else {
                  var url_post = "https://apivucem.econnectpro.mx/vucem/actualizar_validacion/";
                }

                if (server === 1) {
                  data['en_server'] = 1;
                }

                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
              await axios.post(url_post, data)
                .then((res) => {

                })
                .catch((err) => {
                  //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
                })
                .then(() => {
                  self.$root.$dialogLoader.hide();
                });
            }));
            self.getInconsistencias(self.rfc_sel);

        }
      });

    },
    async selectgrupo(){
      await this.getAvanceGlobal();
      await this.getTotal_avance_tipo();
      await this.getxDia();
      await this.getBarras();
    },
     check_all: function() {
      // let arr = this.allChecked ? this.data_inconsistencias.map(row => row.id ) : [];
      let arr = this.allChecked ? this.$refs.vuetable.allFilteredData.map(row => row.id ) : [];
      if (arr.length == 0) {
        this.to_download = [];
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (this.to_download.includes(arr[i])) {
            continue;
          } else {
            this.to_download.push(arr[i]);
          }
        }
      }

    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    regenerarmenu() {
            //Se actualiza la variable store.state.datetime para forzar a recargar el componente de AppBar.vue
            //Esta variable se manda llamar en el archivo App.vue
            this.$store.state.datetime = moment(new Date()).format("x"); //Unix timestamp
     },

    getAvanceGlobal() {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");

      let data = {"estatus": this.inactivos == false ? 1 : 0};
      if (this.id_grupo>0){
        data ={ "grupo":this.id_grupo};
      }
      axios
        .post(this.$hostname + "reportes/avance_global/", data)
        .then((response) => {
          this.data_avanceGlobal = response.data;

          this.pedimentos = this.data_avanceGlobal.reduce(function (prev, cur) {
            return prev + (parseInt(cur.cantidad) || 0);
          }, 0);
          this.archivos = this.data_avanceGlobal.reduce(function (prev, cur) {
            return prev + (parseInt(cur.archivos) || 0);
          }, 0);
          this.inconsistencias = this.data_avanceGlobal.reduce(function (
            prev,
            cur
          ) {
            return prev + (parseInt(cur.inconsistencias) || 0);
          },
          0);

          this.espacio = this.data_avanceGlobal.reduce(function (prev, cur) {
            return prev + (parseInt(cur.espacio) || 0);
          }, 0);
          this.espacio = parseFloat(this.formatDouble(this.espacio / 1048576 / 1024, 2));
        })
        .catch((error) => {
          this.data_avanceGlobal = [];
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    ocultaInconsistencias() {
      this.data_inconsistencias = [];
      this.$refs.vuetable.resetQuery();
      this.to_download = [];
    },
    ocultaAvance() {
      this.data_total_avance_tipo_cliente = [];
    },
    getInconsistencias(rfc) {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let data = {
        rfc: rfc,
      };
      this.rfc_sel = rfc;
      this.$refs.vuetable.resetQuery();
      this.to_download = [];
      this.allChecked = false;
      axios
        .post(this.$hostname + "reportes/pedimentos_auditados/", data)
        .then((response) => {
          this.data_inconsistencias = response.data;
          this.data_total_avance_tipo_cliente = [];
        })
        .catch((error) => {
          this.data_inconsistencias = [];
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getxDia() {
      this.data_x_dia = [];
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let data = {};
      if (this.id_grupo>0){
        data = {"fecha": this.fecha,
                "grupo":this.id_grupo,
                "diaria": this.diaria

              }
      }else{
      data = {
        fecha: this.fecha,
        diaria: this.diaria
      };
      }

      data['errores'] = this.erroresrecu == false ? 0 : 1;
      axios
        .post(this.$hostname + "reportes/total_archivos/", data)
        .then((response) => {
          let a = [];
          let r = response.data;
          let keys = Object.keys(r);
          let obj = null;
          keys.forEach(function (x) {
            obj = Object.assign({ rfc: x }, r[x]);
            a.push(obj);
          });

          this.data_x_dia = a;
        })
        .catch((error) => {
          console.log(error);
          this.data_x_dia = [];
          this.dialog = false;
          this.loading = false;
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
          this.dialog = false;
          this.loading = false;
        });
    },
    getBarras() {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let data = {};
      if (this.id_grupo>0){
        data ={ "grupo":this.id_grupo};
      }
      axios
        .post(this.$hostname + "reportes/get_barras/ ", data)
        .then((response) => {
          this.datos_barras = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.dialog = false;
          this.loading = false;
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
          this.dialog = false;
          this.loading = false;
        });
    },
    getTotal_avance_tipo_cliente(rfc) {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let data = {
        rfc: rfc,
      };
      this.rfc_sel = rfc;
      axios
        .post(this.$hostname + "reportes/total_avance_tipo_cliente/", data)
        .then((response) => {
          let r = response.data;
          let a = [];
          var i = 1;

          for (i = 1; i < 19; i++) {
            if (i != 9 && i != 13 && i != 17) {
              if (a[i] == undefined) a[i] = [];
              r[i.toString()].forEach(function (x) {
                a[i][x.estatus] = x.total;
              });
            }
          }
          this.data_total_avance_tipo_cliente = a;
          this.data_inconsistencias = [];
        })
        .catch((error) => {
          console.log(error);
          this.data_total_avance_tipo_cliente = [];
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getTotal_avance_tipo() {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let data = {};
      if (this.id_grupo>0){
        data ={ "grupo":this.id_grupo};
      }
      axios
        .post(this.$hostname + "reportes/total_avance_tipo/", data)
        .then((response) => {
          let r = response.data;
          let a = [];
          var i = 1;

          for (i = 1; i < 19; i++) {
            if (i != 9 && i != 13 && i != 17) {
              if (a[i] == undefined) a[i] = [];
              r[i.toString()].forEach(function (x) {
                a[i][x.estatus] = x.total;
              });
            }
          }

          this.data_total_avance_tipo = a;
        })
        .catch((error) => {
          console.log(error);
          this.data_total_avance_tipo = [];
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    formatDouble: function (numero, decimales) {
      if (numero == undefined || numero == null || numero == "") numero = 0;
      numero = Number(numero);
      if (isNaN(numero)) {
        return "";
      } else
        return numero.toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    formatBites: function (numero) {
      let n = numero / 1048576;
      if (n > 1024) {
        n = n / 1024;
        n = this.formatDouble(n, 2) + " GB";
      } else {
        n = this.formatDouble(n, 2) + " MB";
      }

      return n;
    },
    formatNumber: function (x) {
      if (x == undefined) return 0;
      x = x.toString();
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    },
    reenviarArchivo(row, server) {
      if(server === 1) {
        var text_i =  "Esta acción volverá a encolar el documento para su recuperación/regeneración en el servidor. ¿Desea continuar?"
      } else {
        var text_i = "Esta acción volverá a encolar el documento para su recuperación/regeneración. ¿Desea continuar?"
      }
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: text_i,
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.reenviar(row, server);
        }
      });
    },

    reenviarArchivoPartidas(row, server) {
      if(server === 1) {
        var text_i =  "Esta acción volverá a encolar el documento para su recuperación/regeneración en el servidor. ¿Desea continuar?"
      } else {
        var text_i = "Esta acción volverá a encolar el documento para su recuperación/regeneración. ¿Desea continuar?"
      }
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: text_i,
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.reenviar(row, server);
        }
      });
    },
    atender(row) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text:
          "Esta acción marcara como atendida la inconsistencia y ya no aparecerá. ¿Desea continuar?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.atendida(row.id);
        }
      });
    },
    atendida: function (id) {
      let data = {
        id_pedimento: id
      };

      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      axios
        .post(this.$hostname + "vucem/revisar_auditoria/", data)
        .then((res) => {
          this.getInconsistencias(this.rfc_sel);
        })
        .catch((err) => {
          //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    reenviarGlosa(row) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text:
          "Esta acción volverá a encolar los archivos faltantes para su recuperación/regeneración. ¿Desea continuar?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.reenviarG(row);
        }
      });
    },
    auditarPedimento(id) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text:
          "Esta acción volverá a auditar el pedimento en busca de inconsistencias. ¿Desea continuar?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.auditar(id);
        }
      });
    },

    reenviar: function (row, server) {
      let data = {
        key: row.id,
        tipo: 1,
        filename: row.no_pedimento,
        estatus: 0, //Se deja en Pendiente para que lo vuelva a encolar
        size: 0,
        error: "",
        usuario: this.$local_storage.get("id_usuario",""),
        origen: "Panel Administrador",
        en_server: 0
      };

      if(pedimento[0].tipo == 'Partidas Incompletas'){
        var url_post = "https://apivucem.econnectpro.mx/vucem/actualizar_validacion_partidas/";
      } else if(pedimento[0].tipo == 'Estado Pedimento'){
        var url_post = "https://apivucem.econnectpro.mx/vucem/actualizar_validacion/";

        data = {
          key: row.id,
          tipo: 4,
          filename: "Estado-" + row.no_pedimento,
          estatus: 0, //Se deja en Pendiente para que lo vuelva a encolar
          size: 0,
          error: "",
          usuario: this.$local_storage.get("id_usuario",""),
          origen: "Panel Administrador",
          en_server: 0
        }
      } else {
        var url_post = "https://apivucem.econnectpro.mx/vucem/actualizar_validacion/";
      }

      if (server === 1) {
        data['en_server'] = 1;
      }

      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      axios.post(url_post, data)
        .then((res) => {
          this.getInconsistencias(this.rfc_sel);
        })
        .catch((err) => {
          //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    reenviarG: function (row) {
      let data = {
        rfc: row.rfc,
        fecha_de: row.barra.fecha_inicio,
        fecha_a: row.barra.fecha_fin,
        archivos: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19],
        barra: true,
        usuario: this.$local_storage.get("id_usuario",""),
        origen: "Panel Administrador"
      };

      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      axios
        .post(this.$hostname + "vucem/reprogramar_documentos/", data)
        .then((res) => {
          this.getBarras();
        })
        .catch((err) => {
          //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    auditar: function (id) {
      let data = {
        key: id,
      };

      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      axios
        .post(this.$hostname + "pedimentos/auditar/", data)
        .then((res) => {
          this.getInconsistencias(this.rfc_sel);
        })
        .catch((err) => {
          //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getGrupos: function () {

            axios
                .get(this.$hostname + "grupos/")
                .then(response => {
                    this.grupos = response.data;

                    this.grupos = this.grupos.sort(function (a, b) {
                        return a.nombre > b.nombre ? 1 : -1;
                    });


                })
                .catch(error => {
                    console.log(error);
                });
     },
     getProgramadas: function () {

            axios
                .post(this.$hostname + "consulta_diaria/get_consultas_reporte/")
                .then(response => {
                    this.programadas = response.data;
                     for (var k in this.programadas) {
                      this.programadas[k].fecha_solicitud = this.parseDate(this.programadas[k].fecha_solicitud);
                      this.programadas[k].fecha_inicial = this.parseDate(this.programadas[k].fecha_inicial);
                      this.programadas[k].fecha_final = this.parseDate(this.programadas[k].fecha_final);
                      this.programadas[k].estatus = this.programadas[k].estatus==0?"Pendiente":"Procesado";
                    }
                    this.programadas = this.programadas.sort(function (a, b) {
                      return a.id < b.id ? 1 : -1;
                  });
                })
                .catch(error => {
                    console.log(error);
                });
     },
     getlogins: function () {

            axios
                .post("https://apireportes.econnectpro.mx/reportes/get_accesos_clientes/", {"fecha_de": this.fecha_de_login, "fecha_a": this.fecha_a_login})
                .then(response => {
                  this.data_login = response.data;
                })
                .catch(error => {
                    console.log(error);
                }).then(() => {
                  this.$root.$dialogLoader.hide();
                  this.dialog_login = false;
                  this.loading = false;
                });;
     },
    getcalendar() {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let self = this;
      self.data_calendar = [];

      let primer_mes=0;
      let ultimo_mes=0;
      let faltantes=0;
      let i;
      let total = 0;
      let meses_faltantes = '';
      var f = new Date();
      let y = f.getFullYear();
      let m = f.getMonth() + 1;
      let data = {};
       let faltantex = "";
      if (this.id_grupo>0){
        data ={ "grupo":this.id_grupo};
      }
      axios
        //.post(this.$hostname + "reportes/calendario_clientes/", data)
        .post("https://apireportes.econnectpro.mx/reportes/calendario_clientes/", data)
        .then((response) => {
           let r = response.data;

           r.forEach(
             function(item){
               faltantes= 0;
               total = 0;
               meses_faltantes = '';

               Object.keys(item.calendario).forEach(
                 function (a){
                   i=1;
                   faltantex = '';
                   Object.keys(item.calendario[a]).forEach(
                     function(mes){
                        if (item.calendario[a][mes] == false && (a < y || (mes < m && a == y) )){
                          faltantes ++;
                          meses_faltantes +=  self.meses[mes] + '-' + a + ", ";
                        }
                        if(item.calendario[a][mes] == true && primer_mes==0){
                          primer_mes = i;
                        }
                        if(item.calendario[a][mes] == true ){
                          ultimo_mes = i;
                        }

                        if(item.calendario[a][mes] == 'X' ){
                          faltantex =  'X' + i ;
                        }
                        total ++;
                        i++;
                     }
                   )
                 }
               );
               if (Object.keys(item.calendario)[0] > 0){

                let ultimo_a = Object.keys(item.calendario)[Object.keys(item.calendario).length -1] ;


                var date1 = new Date(ultimo_a, ultimo_mes, 1);
                var date2 = new Date(y,m,1);
                var diffYears = date2.getFullYear()-date1.getFullYear();
                var diffMonths = date2.getMonth()-date1.getMonth();
                var diffDays = date2.getDate()-date1.getDate();

                var months = (diffYears*12 + diffMonths);
                if(diffDays>0) {
                    months += '.'+diffDays;
                } else if(diffDays<0) {
                    months--;
                    months += '.'+(new Date(date2.getFullYear(),date2.getMonth(),0).getDate()+diffDays);
                }
                months = months -1;


                if (months>0 && (ultimo_a < y || (ultimo_a == y && ultimo_mes < m) ) ){
                  faltantes += months;
                  if (months>1 ){
                    meses_faltantes += 'ULTIMOS ' + months + ' MESES';
                  }else{
                      meses_faltantes += 'ULTIMO MES';
                  }
                }



                    self.data_calendar.push(
                                    {'rfc': item.rfc,
                                    'inicio': self.meses[primer_mes] + " - " +  Object.keys(item.calendario)[0]   ,
                                    'fin':  self.meses[ultimo_mes] + " - " +  ultimo_a,
                                    'falta':faltantes,
                                    'total':total,
                                    'fecha': item.ultima == undefined?"":item.ultima.substr(0,10),
                                    'meses_faltantes': meses_faltantes
                                    }
                                  );

               }else{
                 self.data_calendar.push(
                                    {'rfc': item.rfc,
                                    'inicio': "NINGUNO",
                                    'fin': "NINGUNO",
                                    'falta':0,
                                    'total':0,
                                    'fecha':""
                                    }
                                  );

               }



             }
           );

        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
  },
};
</script>

<style scoped>

#dvswtich >>> div {
  margin: 0 !important;
  padding: 0 !important;
}
.footer-hide>>>.VuePagination {
    display: none;
}

.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
</style>
